"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewOverlay = void 0;
/**
 * Api client allowing an empty electron BrowserView to be rendered
 * in the current window with the specified bounds.
 *
 * Please note, only one  view based overlay can be rendered at a time per runtime.
 * @ignore
 */
class ViewOverlay {
    // eslint-disable-next-line
    constructor(wire) {
        this.wire = wire;
        /**
         * Sets the style of the root <html> element of the view overlay webcontent.
         * @param style A partial collection of Css style declarations to set.
         */
        this.setStyle = async (style) => {
            await this.wire.sendAction('set-overlay-style', { style });
        };
        /**
         * Renders the overlay at the specified position relative to the calling window.
         * @param options Bounds and background color to display in the overlay.
         */
        this.renderOverlay = async (bounds) => {
            await this.wire.sendAction('render-overlay', { bounds });
        };
        /**
         * Removes the overlay from the current window.
         */
        this.detachOverlay = async () => {
            await this.wire.sendAction('detach-overlay');
        };
    }
    /**
     * Allows setting all OpenFin views to ignore or consume mouse events.
     *
     * This can help with the rendering of view overlays that depend on OpenFin views not consuming mouse events.
     *
     * @param enabled If true, all mouse events are ignored by openfin views. If false, all OpenFin views will consume mouse events.
     */
    async setIgnoreViewMouseEvents(enabled) {
        await this.wire.sendAction('set-ignore-all-view-mouse-events', {
            enabled
        });
    }
}
exports.ViewOverlay = ViewOverlay;
